<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>/* eslint-disable */
import './assets/scss/styles.scss'

import { detect } from 'detect-browser';
const browser = detect();

export default {
    name: 'App',
    created() {
        // Browser and OS classes
        document.documentElement.classList.add(`is-${browser.os.replace(' ', '-').toLowerCase()}`)
        document.documentElement.classList.add(`is-${browser.name}`)
    },
    mounted() {

        let delay = new Date()
        delay = (delay - window.loaderStart)
        delay = delay > 2000 ? 0 : (2000 - delay)

        // Remove Loader
        const $loader = document.querySelector('#js-loader-init')

        setTimeout(() => {
            $loader.classList.add('is-hidden')
            setTimeout(() => {
                $loader.parentNode.removeChild($loader);
            }, 800);
        }, delay);
    }
}
</script>
